import React from "react";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import { formatCurrency } from "./budgetUtils";

export function SectionCard({ title, subtitle, children, dark = false }) {
  return (
    <div
      className={`${dark ? "bg-black/80" : "bg-[#130018]"} rounded-3xl border border-[#2A0047] p-5 sm:p-6 shadow-xl flex flex-col gap-5 relative overflow-hidden`}
    >
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#9E4CFF] to-transparent opacity-80" />
      <div className="flex flex-col gap-1">
        <h3 className="text-lg font-semibold text-[#C9A6FF]">{title}</h3>
        {subtitle ? <p className="text-xs text-[#D8D8D8]">{subtitle}</p> : null}
      </div>
      {children}
    </div>
  );
}

export function StatTile({ label, value, muted }) {
  return (
    <div className="bg-black/80 border border-[#2A0047] rounded-2xl p-5 sm:p-6 flex flex-col gap-2 shadow-xl">
      <span className="text-xs uppercase tracking-widest text-[#9E4CFF]">{label}</span>
      <span className={`text-2xl md:text-3xl font-semibold ${muted ? "text-[#D8D8D8]" : "text-white"}`}>
        {value}
      </span>
    </div>
  );
}

export function ProgressBar({ value, label }) {
  const clampedValue = Math.min(100, Math.max(0, value));

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center justify-between gap-3">
        {label ? <span className="text-[11px] uppercase tracking-widest text-[#9E4CFF]">{label}</span> : <span />}
        <span className="text-[11px] text-[#D8D8D8]">{Math.round(clampedValue)}%</span>
      </div>
      <div className="h-3.5 w-full bg-[#130018] rounded-full overflow-hidden border border-[#2A0047]">
        <div
          className="h-full rounded-full bg-gradient-to-r from-[#7B2CFF] via-[#9E4CFF] to-[#FF6BD5] shadow-[0_0_12px_#9E4CFF]"
          style={{ width: `${clampedValue}%` }}
        />
      </div>
    </div>
  );
}

export function LineChartComponent({ data, valueFormatter = formatCurrency }) {
  return (
    <div className="h-72 w-full">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data}>
          <XAxis dataKey="name" stroke="#9E4CFF" tick={{ fill: "#C9A6FF" }} />
          <YAxis stroke="#9E4CFF" tick={{ fill: "#C9A6FF" }} />
          <Tooltip
            contentStyle={{ background: "#130018", border: "1px solid #2A0047", color: "#D8D8D8" }}
            labelStyle={{ color: "#C9A6FF" }}
            formatter={(value) => valueFormatter(value)}
          />
          <Line type="monotone" dataKey="value" stroke="#9E4CFF" strokeWidth={3} dot={false} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}